import React, { useEffect, useRef, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import { Modal, Button, Form } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useTranslation } from "react-i18next";
import { ProductsService } from "../service";
import { ErrorToast, SuccessToast } from "../../../shared/toasters/toasters";
import { useParams } from "react-router";
import { ConfirmDelete } from "../../../shared/components/ConfirmDelete";
import "tui-image-editor/dist/tui-image-editor.css";
// @ts-ignore
import ImageEditor from "@toast-ui/react-image-editor";
import { lightTheme } from "../../../shared/toastImageEditor/theme";
import { darkTheme } from "../../../shared/toastImageEditor/theme";
import { useSelector } from "react-redux";
import { IAllStates } from "../../../store/rootReducer";
import Switch from "react-switch";
const ProductMediaPictures = ({
  pictures,
  setPictures,
  isWorkflowUpdate,
  setTriggerUpdatePictures,
}: any) => {
  const [selectedIds, setSelectedIds] = useState<number[]>([]);
  const lightOrDarkMode = useSelector(
    (state: IAllStates) => state.lightOrDarkMode
  );
  const [editModal, setEditModal] = useState<{
    show: boolean;
    pic: any | null;
  }>({
    show: false,
    pic: null,
  });
  const [editModalResize, setEditModalResize] = useState<{
    show: boolean;
  }>({
    show: false,
  });
  const [editModalName, setEditModalName] = useState<{
    show: boolean;
  }>({
    show: false,
  });
  const [editModalFormat, setEditModalFormat] = useState<{
    show: boolean;
  }>({
    show: false,
  });
  const { id, productId } = useParams();
  const [editName, setEditName] = useState("");
  const [bulkState, setBulkState] = useState(false);
  const [editWidth, setEditWidth] = useState<number | "">("");
  const [editNameBulk, setEditNameBulk] = useState<string | "">("");
  const [editHeight, setEditHeight] = useState<number | "">("");
  const [editFormat, setEditFormat] = useState("png");
  const [selectedClient, setSelectedClient] = useState<any | undefined>();
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);
  const [imageUrl, setImageUrl] = useState<string | null>(null);
  const [imageId, setImageId] = useState<number | null>(null);
  useEffect(() => {
    if (selectedIds.length > 0) {
      const firstId = selectedIds[0];
      const foundPic = pictures.find((pic: any) => pic.id === firstId);

      if (foundPic) {
        console.log(foundPic);

        setImageUrl(foundPic.path || "");
        setImageId(foundPic.id);
      }
    }
  }, [selectedIds, pictures]);
  // const [imageUrl, setImageUrl] = useState(
  //   "https://www.radios.rs/media/izvodjaci500x500/OKTOBAR-1864.jpg"
  // );
  const deleteHandler = () => {
    ProductsService.mediaUpdateImageDelete({ pictures: selectedIds })
      .then(() => {
        // update lokalnog stanja
        setTriggerUpdatePictures((prev: boolean) => !prev);
        SuccessToast(`${t("toasts.successfully_deleted")}`);
        setSelectedIds([]);
        setImageUrl(null);
      })
      .catch((error) => ErrorToast(error));
  };
  const { t } = useTranslation();
  const onDragEnd = (result: any) => {
    if (!result.destination) return;
    const items = Array.from(pictures);
    const [reordered] = items.splice(result.source.index, 1);
    items.splice(result.destination.index, 0, reordered);
    setPictures(items);
    console.log(items);
    ProductsService.sortPictures(
      items?.map((img: any) => String(img.id)),
      Number(isWorkflowUpdate ? productId : id)
    )
      .then((response) => {
        SuccessToast(`${t("toasts.successfully_sorted")}`);
      })
      .catch((error) => ErrorToast(error));
  };

  const toggleSelect = (id: number) => {
    setSelectedIds((prev) => {
      if (!bulkState) {
        return prev.includes(id) ? [] : [id];
      }
      return prev.includes(id) ? prev.filter((x) => x !== id) : [...prev, id];
    });
  };
  const editorRef = useRef<any>(null);

  const handleSave = () => {
    const editorInstance = editorRef.current?.getInstance();
    const dataURL = editorInstance?.toDataURL();

    if (!dataURL) return;
    const blob = dataURLtoBlob(dataURL);
    const file = new File([blob], "edited-image.png", { type: "image/png" });
    const formData = new FormData();
    formData.append("file", file);
    formData.append(
      "body",
      JSON.stringify({
        pictureId: imageId,
      })
    );

    ProductsService.mediaReplaceImage(formData)
      .then((response) => {
        setTriggerUpdatePictures((prev: boolean) => !prev);
      })
      .catch((error) => ErrorToast(error));
  };

  function dataURLtoBlob(dataURL: string) {
    const arr = dataURL.split(",");
    const mime = arr[0].match(/:(.*?);/)?.[1] || "image/png";
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
  }

  const openEditModal = (pic: any) => {
    setEditModal({ show: true, pic });
    setEditName(pic.file.nameOriginal.replace(/\.[^/.]+$/, ""));
    setEditWidth(pic.width ?? "");
    setEditHeight(pic.height ?? "");
    setEditFormat(pic.file.mime.split("/")[1] ?? "png");
  };

  const saveEdit = async () => {
    if (!editModal.pic) return;

    const params = {
      pictureId: editModal.pic.id,
      nameOriginal: editName,
      extension: editFormat,
      width: editWidth,
      height: editHeight,
    };

    ProductsService.mediaUpdateImage(params)
      .then(() => {
        // update lokalnog stanja
        setTriggerUpdatePictures((prev: boolean) => !prev);
        SuccessToast(`${t("toasts.successfully_updated")}`);
        setEditModal({ show: false, pic: null });
      })
      .catch((error) => ErrorToast(error));
  };
  useEffect(() => {
    const headerButtons = document.querySelector(
      ".tui-image-editor-header-buttons"
    );
    const logoEditor = document.querySelector(".tui-image-editor-header-logo");

    if (headerButtons) {
      headerButtons.remove();
    }
    if (logoEditor) {
      logoEditor.remove();
    }
  });
  const handleChangeSwitch = () => {
    setBulkState((prev: boolean) => !prev);
    setSelectedIds(selectedIds?.length > 0 ? [selectedIds[0]] : []);
  };
  // Rename (jedna slika)
  const saveRename = async () => {
    if (!selectedIds?.length) return;

    const params = {
      pictures: selectedIds,
      name: editNameBulk,
    };

    ProductsService.mediaUpdateImageRename(params)
      .then(() => {
        SuccessToast(`${t("toasts.successfully_renamed")}`);
        setEditModalName({ show: false });
        setTriggerUpdatePictures((prev: boolean) => !prev);
      })
      .catch((error) => ErrorToast(error));
  };

  // Reformat (više slika)
  const saveReformat = async () => {
    if (!selectedIds?.length) return;

    const params = {
      pictures: selectedIds,
      extension: editFormat,
    };

    ProductsService.mediaUpdateImageReformat(params)
      .then(() => {
        // update lokalnog stanja

        SuccessToast(`${t("toasts.successfully_reformatted")}`);
        setEditModalFormat({ show: false });
        setTriggerUpdatePictures((prev: boolean) => !prev);
      })
      .catch((error) => ErrorToast(error));
  };

  // Resize (više slika)
  const saveResize = async () => {
    if (!selectedIds?.length) return;

    const params = {
      pictures: selectedIds,
      width: editWidth,
      height: editHeight,
    };

    ProductsService.mediaUpdateImageResize(params)
      .then(() => {
        // update lokalnog stanja

        SuccessToast(`${t("toasts.successfully_resized")}`);
        setEditModalResize({ show: false });
        setTriggerUpdatePictures((prev: boolean) => !prev);
      })
      .catch((error) => ErrorToast(error));
  };

  return (
    <>
      <div className="d-flex justify-content-end align-items-center">
        <button
          className="btn  btn-secondary d-flex align-items-center me-2"
          onClick={() => setEditModalFormat({ show: true })}
          disabled={selectedIds?.length < 2}
        >
          <i className="ri-image-edit-fill me-1" />
          {`${t("global.format")}`}
        </button>
        <button
          className="btn  btn-info d-flex align-items-center me-2"
          onClick={() => setEditModalName({ show: true })}
          disabled={selectedIds?.length < 2}
        >
          <i className="ri-edit-2-fill me-1" />
          {`${t("global.name")}`}
        </button>
        <button
          className="btn  btn-primary d-flex align-items-center me-2"
          onClick={() => setEditModalResize({ show: true })}
          disabled={selectedIds?.length < 2}
        >
          <i className="ri-ruler-2-line me-1" />
          {`${t("global.resize")}`}
        </button>
        <button
          className="btn  btn-danger d-flex align-items-center me-2"
          onClick={() => handleShow()}
          disabled={selectedIds?.length === 0}
        >
          <i className="ri-delete-bin-fill me-1" />
          {`${t("global.delete")}`}
        </button>
      </div>
      <Modal
        show={editModal.show}
        onHide={() => setEditModal({ show: false, pic: null })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{`${t("media.edit_picture")}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>{`${t("global.name")}`}</Form.Label>
              <Form.Control
                type="text"
                value={editName}
                onChange={(e) => setEditName(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>{`${t("global.width")}`}</Form.Label>
              <Form.Control
                type="number"
                value={editWidth}
                onChange={(e) => setEditWidth(Number(e.target.value))}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>{`${t("global.height")}`}</Form.Label>
              <Form.Control
                type="number"
                value={editHeight}
                onChange={(e) => setEditHeight(Number(e.target.value))}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label> {`${t("global.format")}`}</Form.Label>
              <Form.Select
                value={editFormat}
                onChange={(e) => setEditFormat(e.target.value)}
              >
                <option value="jpg">JPG</option>
                <option value="jpeg">JPEG</option>
                <option value="png">PNG</option>
                {/* <option value="webp">WEBP</option>
                <option value="gif">GIF</option>
                <option value="bmp">BMP</option>
                <option value="tiff">TIFF</option>
                <option value="svg">SVG</option>
                <option value="heic">HEIC</option>
                <option value="ico">ICO</option> */}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setEditModal({ show: false, pic: null })}
          >
            {`${t("global.cancel")}`}
          </Button>
          <Button variant="primary" onClick={saveEdit}>
            {`${t("global.save")}`}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={editModalFormat.show}
        onHide={() => setEditModalFormat({ show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{`${t("media.edit_pictures")}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label> {`${t("global.format")}`}</Form.Label>
              <Form.Select
                value={editFormat}
                onChange={(e) => setEditFormat(e.target.value)}
              >
                <option value="jpg">JPG</option>
                <option value="jpeg">JPEG</option>
                <option value="png">PNG</option>
                {/* <option value="webp">WEBP</option>
                <option value="gif">GIF</option>
                <option value="bmp">BMP</option>
                <option value="tiff">TIFF</option>
                <option value="svg">SVG</option>
                <option value="heic">HEIC</option>
                <option value="ico">ICO</option> */}
              </Form.Select>
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setEditModal({ show: false, pic: null })}
          >
            {`${t("global.cancel")}`}
          </Button>
          <Button variant="primary" onClick={saveReformat}>
            {`${t("global.save")}`}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={editModalResize.show}
        onHide={() => setEditModalResize({ show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{`${t("media.edit_pictures")}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>{`${t("global.width")}`}</Form.Label>
              <Form.Control
                type="number"
                value={editWidth}
                onChange={(e) => setEditWidth(Number(e.target.value))}
              />
            </Form.Group>
            <Form.Group className="mb-2">
              <Form.Label>{`${t("global.height")}`}</Form.Label>
              <Form.Control
                type="number"
                value={editHeight}
                onChange={(e) => setEditHeight(Number(e.target.value))}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setEditModal({ show: false, pic: null })}
          >
            {`${t("global.cancel")}`}
          </Button>
          <Button variant="primary" onClick={saveResize}>
            {`${t("global.save")}`}
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={editModalName.show}
        onHide={() => setEditModalName({ show: false })}
        centered
      >
        <Modal.Header closeButton>
          <Modal.Title>{`${t("media.edit_pictures")}`}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-2">
              <Form.Label>{`${t("global.name")}`}</Form.Label>
              <Form.Control
                type="text"
                value={editNameBulk}
                onChange={(e) => setEditNameBulk(e.target.value)}
              />
            </Form.Group>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button
            variant="secondary"
            onClick={() => setEditModal({ show: false, pic: null })}
          >
            {`${t("global.cancel")}`}
          </Button>
          <Button variant="primary" onClick={saveRename}>
            {`${t("global.save")}`}
          </Button>
        </Modal.Footer>
      </Modal>
      <div className="row mt-3">
        <div className="col-1">
          <div className="d-flex direction-column align-items-center mb-3">
            <label className="me-2 mb-0">{`${t("media.bulk")}`}</label>
            <Switch
              className="my-auto"
              onChange={handleChangeSwitch}
              checked={bulkState}
            />
          </div>
          <DragDropContext onDragEnd={onDragEnd}>
            <Droppable droppableId="pictures" direction="vertical">
              {(provided: any) => (
                <div
                  className="d-flex flex-column align-items-center g-2"
                  {...provided.droppableProps}
                  ref={provided.innerRef}
                >
                  {pictures.map((pic: any, index: number) => (
                    <Draggable
                      key={pic.id}
                      draggableId={pic.id.toString()}
                      index={index}
                    >
                      {(provided: any) => (
                        <div
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                          className={`mb-2`}
                          style={{
                            cursor: "pointer",
                            border: selectedIds.includes(pic.id)
                              ? "3px solid #ffbb3a"
                              : `3px solid ${
                                  lightOrDarkMode === "light"
                                    ? "#f3f3f9"
                                    : "#1a1d21"
                                }`,
                            width: "100%",
                            ...provided.draggableProps.style,
                          }}
                          onClick={() => toggleSelect(pic.id)}
                          onContextMenu={(e) => {
                            e.preventDefault();
                            openEditModal(pic);
                          }}
                        >
                          <img
                            src={pic.path}
                            alt={pic.file.nameOriginal}
                            style={{
                              width: "100%",
                              height: "60px",
                              objectFit: "cover",
                              display: "block",
                            }}
                          />
                        </div>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </div>
              )}
            </Droppable>
          </DragDropContext>
        </div>

        {/* Glavni Image Editor */}
        <div className="col-11" style={{ position: "relative" }}>
          <ImageEditor
            key={`${lightOrDarkMode}-${imageUrl}`}
            ref={editorRef}
            includeUI={{
              loadImage: {
                path: `${imageUrl ?? ""}`, // početna slika
                name: "SampleImage",
              },
              theme: lightOrDarkMode === "light" ? lightTheme : darkTheme,
              menu: [
                "crop",
                "flip",
                "rotate",
                "draw",
                "shape",
                "icon",
                "text",
                "mask",
                "filter",
                "resize",
              ],
              initMenu: "filter",
              uiSize: {
                width: "100%",
                height: "90vh",
              },
              menuBarPosition: "bottom",
            }}
            cssMaxHeight={600}
            cssMaxWidth={800}
            selectionStyle={{
              cornerSize: 20,
              rotatingPointOffset: 70,
            }}
            usageStatistics={false}
          />
          <button
            className="btn  btn-primary d-flex align-items-center me-2"
            style={{
              position: "absolute",
              top: "10px",
              right: "10px",
              zIndex: 10,
            }}
            onClick={handleSave}
            disabled={Boolean(!imageUrl)}
          >
            {`${t("global.save")}`}
          </button>
        </div>
      </div>

      <ConfirmDelete
        show={show}
        setShow={setShow}
        itemName={`${selectedIds?.length} image${
          selectedIds?.length > 1 ? "s" : ""
        }`}
        deleteHandler={deleteHandler}
        selectedProduct={selectedClient}
      />
    </>
  );
};

export default ProductMediaPictures;
